import { useState } from 'react';
import { useRevokeAllSessions } from '@/services/queries';
import { Button } from '@/shared/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/ui/dialog';

export function RevokeAllSessionsCard() {
  const [open, setOpen] = useState(false);
  const revoke = useRevokeAllSessions();

  return (
    <div className="flex items-center justify-between gap-6 rounded-2xl border border-destructive/40 bg-card p-5">
      <div className="space-y-0.5">
        <p className="text-[13.5px] font-semibold text-destructive">Sign out every admin</p>
        <p className="text-[12.5px] text-muted-foreground">
          Signs every NuDent staff account out of every device, yours included. Customers stay
          signed in.
        </p>
      </div>

      <Button
        variant="outline"
        className="border-destructive text-destructive hover:bg-destructive/10"
        onClick={() => {
          setOpen(true);
        }}
      >
        Sign out everyone
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Sign out every admin?</DialogTitle>
            <DialogDescription>
              Every NuDent staff account - including yours - is signed out immediately on every
              device, and everyone will need to sign in again with their password and authenticator
              code. Use this if you think an admin session has been compromised. Customer portal and
              desktop sessions are not affected.
            </DialogDescription>
          </DialogHeader>

          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="destructive"
              disabled={revoke.isPending}
              onClick={() => {
                revoke.mutate(undefined, {
                  onSuccess: () => {
                    setOpen(false);
                  },
                });
              }}
            >
              {revoke.isPending ? 'Signing everyone out…' : 'Sign out everyone'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
